import { Link } from "react-router-dom";
import styled from "styled-components";
import BasedOnLogo from "../../assets/img/BasedOnLogo.svg";

export default function Logo() {
	return (
		<StyledLink to={"/"}>
			<img src={BasedOnLogo} alt="BasedOn" />
		</StyledLink>
	);
}

const StyledLink = styled(Link)`
	display: flex;
	align-content: center;
`;
